/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateMixedSaleDto } from '../models/CreateMixedSaleDto';
import type { SaleFulfillmentDetailResponseDto } from '../models/SaleFulfillmentDetailResponseDto';
import type { SalesOrder } from '../models/SalesOrder';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SalesOrdersMixedBranchFulfillmentService {
  /**
   * Confirm a sale that may include items from other branches/warehouse
   * Local items are sold immediately; remote items each generate an auto SOL and are held until the whole sale completes (see mixed-branch-sale-fulfillment-spec.md).
   * @param requestBody
   * @returns SalesOrder Mixed-branch sale confirmed
   * @throws ApiError
   */
  public static saleFulfillmentControllerConfirmMixedSale(
    requestBody: CreateMixedSaleDto,
  ): CancelablePromise<SalesOrder> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/sales-orders/mixed',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request - validation errors`,
      },
    });
  }
  /**
   * Finalize a mixed-branch sale once all remote pieces arrived
   * Idempotent when fulfillment_status is already COMPLETED (auto-closed on last receive).
   * @param id
   * @returns SalesOrder Fulfillment finalized
   * @throws ApiError
   */
  public static saleFulfillmentControllerFinalizeFulfillment(
    id: number,
  ): CancelablePromise<SalesOrder> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/sales-orders/{id}/finalize-fulfillment',
      path: {
        id: id,
      },
      errors: {
        400: `Not ready to finalize`,
        404: `Order not found`,
      },
    });
  }
  /**
   * Fulfillment group detail for a mixed-branch sale
   * Returns one entry per remote source location involved in the sale, with its SOL/TRL linkage and status.
   * @param id
   * @returns SaleFulfillmentDetailResponseDto Fulfillment groups
   * @throws ApiError
   */
  public static saleFulfillmentControllerGetFulfillmentDetail(
    id: number,
  ): CancelablePromise<SaleFulfillmentDetailResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales-orders/{id}/fulfillment',
      path: {
        id: id,
      },
      errors: {
        404: `Order not found`,
      },
    });
  }
}
